import React, { useMemo } from "react"
import { Button } from "reactstrap"

const Pagination = ({ currentPage, totalPages, setCurrentPage }) => {
  const pageNumbers = useMemo(() => {
    const pageNumbers = []
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i)
    }
    return pageNumbers
  }, [totalPages])

  return (
    <div className="d-flex justify-content-between align-items-center">
      <div className="d-flex gap-2">
        <Button
          color="light"
          size="sm"
          outline
          onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
          disabled={currentPage === 1}
          data-testid="prev-page-button"
        >
          ก่อนหน้า
        </Button>
        <Button
          color="light"
          size="sm"
          outline
          onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
          disabled={currentPage === totalPages}
          data-testid="next-page-button"
        >
          ถัดไป
        </Button>
      </div>
      <div className="text-lg" data-testid="pagination-info">
        หน้า {currentPage} จาก {totalPages}
      </div>
    </div>
  )
}

export default Pagination
